var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { FileUploader } from '../FileUploader';
export const MAX_HEIGHT = 256;
export const MAX_WIDTH = 256;
const resize = (image) => __awaiter(void 0, void 0, void 0, function* () {
    let width = image.width;
    let height = image.height;
    if (width > height) {
        width = Math.round((width * MAX_HEIGHT) / height);
        height = MAX_HEIGHT;
    }
    else {
        height = Math.round((height * MAX_WIDTH) / width);
        width = MAX_WIDTH;
    }
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    if (ctx)
        ctx.drawImage(image, 0, 0, width, height);
    return new Promise((resolve) => {
        canvas.toBlob((blob) => {
            resolve(blob);
        }, 'image/jpeg', 0.5);
    });
});
export const AvatarUploader = ({ children, onChange }) => {
    const handler = (files) => new Promise((resolve, reject) => {
        const file = files[0];
        if (!file) {
            resolve(null);
            return;
        }
        const reader = new window.FileReader();
        reader.onerror = () => {
            reject();
        };
        reader.onload = (e) => {
            var _a;
            const res = (_a = e.target) === null || _a === void 0 ? void 0 : _a.result;
            if (!res)
                return;
            const blob = new Blob([res]);
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            window.URL = window.URL || window.webkitURL;
            const blobURL = window.URL.createObjectURL(blob);
            const image = new Image();
            image.src = blobURL;
            image.onload = () => __awaiter(void 0, void 0, void 0, function* () {
                const blob = yield resize(image);
                if (!blob)
                    reject();
                else
                    resolve({
                        data: new File([blob], file.name, {
                            type: blob.type,
                            lastModified: Date.now()
                        }),
                        preview: blobURL
                    });
            });
            image.onerror = () => {
                reject();
            };
        };
        reader.readAsArrayBuffer(file);
    }).then((file) => {
        if (file)
            onChange(file.data, file.preview);
    });
    return (React.createElement(FileUploader, { accept: 'image/jpeg, image/png', onChange: handler }, (upload) => children(upload)));
};
//# sourceMappingURL=index.js.map